module.exports = __webpack_public_path__ + "static/media/icon-heart-active.7a2065c2.svg";